import { getTokens } from '../../../../../auth/AuthState';
import API from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getAllActions } from '../../../../../store/ai2';
import { useTriggerUpdate } from '../../../../../context';

export const usePatchAction = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const { triggerNotificationUpdate } = useTriggerUpdate();

  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  const location = useLocation();
  const dispatch = useDispatch();

  const postPatchAction = async (patchActionPayload) => {
    setIsLoading(true);
    const searchParams = new URLSearchParams(location.search);
    const access_token = searchParams.get('access_token');
    try {
      const { id: authorization_token } = await getTokens();

      let options = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authorization_token,
        },
      };
      const payload = {
        ...patchActionPayload,
        tenancyId: selectedTenancy.tenancy_id,
        access_token: access_token,
      };
      const result = await API.post(`action`, { ...payload }, options);

      await dispatch(await getAllActions(access_token, selectedTenancy));
      triggerNotificationUpdate();
      return result;
    } catch (error) {
      console.error('An error occurred during patch action', error);
      setErrorMessage(
        error?.response?.data?.message || 'Unknown error in patch action',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postPatchAction,
    errorMessage,
    isLoading,
  };
};
